<template>
  <div class="about">
    <MainComponent sectionName="about" />

    <div class="container-fluid">
      <section>
        <div class="row justify-content-center">
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 my-5"
          >
            <h1 class="my-auto text-size-32 fw-bold text-center text-size-32">
              QUIENES SOMOS
            </h1>
          </div>
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 col-xxl-10"
          >
            <p class="text-size-28 mt-3">
              Plomeros a tu alance es un equipo de fontaneros que ofrece
              servicios a domicilio en Venezuela, específicamente en el Distrito
              Capital. Nos destacamos por ofrecer un servicio garantizado y
              cercano a nuestros usuarios, construyendo confianza a través de
              nuestro profesionalismo. No somos solo un servicio de fontanería;
              somos tu solución confiable y la garantía de resultados
              excepcionales para tus necesidades de fontanería.
            </p>
          </div>
        </div>
      </section>

      <section>
        <div class="my-7">
          <div class="row justify-content-center">
            <div
              class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 fix-about-image"
            >
              <img
                src="../assets/images/about/image_1.jpg"
                alt="Plomeros 911 mision"
                class="w-75 rounded-4"
              />
            </div>
            <div
              class="offset-xl-1 offset-xxl-1 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 my-auto"
            >
              <h3 class="text-size-32 fw-bold text-center text-size-32">
                MISION
              </h3>
              <p class="text-size-28 mt-4">
                Satisfacer las necesidades de nuestro clientes, brindar una
                buena atención.
              </p>
            </div>
          </div>

          <div class="row justify-content-center mt-10">
            <div
              class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 my-auto"
            >
              <h3 class="text-size-32 fw-bold text-center text-size-32">
                VISION
              </h3>
              <p class="text-size-28 mt-4">
                Ser una empresa líder en la prestación de servicio de plomeria
                que emplea tecnología de punta.
              </p>
            </div>
            <div
              class="offset-xl-1 offset-xxl-1 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 my-auto fix-about-image"
            >
              <img
                src="../assets/images/about/image_2.jpg"
                alt="Plomeros 911 vision"
                class="w-75 rounded-4"
              />
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="row justify-content-center">
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 my-5"
          >
            <h3 class="my-auto text-size-32 fw-bold text-center text-size-32">
              SOBRE NUESTRO PUBLICO Y NOSOTROS
            </h3>
          </div>
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 col-xxl-10"
          >
            <p class="text-size-28 mt-3">
              En Plomeros a tu Alcance, entendemos que nuestro éxito radica en
              la satisfacción de nuestros clientes. Nos enorgullece decir que
              nuestra historia está escrita por la confianza que nuestros
              clientes depositan en nosotros. Nosotros, como equipo, valoramos
              cada conexión con nuestra comunidad y nos esforzamos por superar
              sus expectativas en cada proyecto.
            </p>
            <p class="text-size-28 mt-5">
              Nuestro compromiso es claro: proporcionar servicios de fontanería
              de calidad que no solo resuelven problemas, sino que también
              construyen relaciones duraderas. Descubre más sobre nuestra
              dedicación y el valor que le damos a nuestra relación con cada uno
              de ustedes, porque en Plomeros a tu Alcance, ustedes son nuestra
              inspiración y nuestro mayor activo.
            </p>
          </div>
        </div>
      </section>

      <section>
        <div class="my-7">
          <div class="row justify-content-center">
            <div
              class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 my-auto fix-about-image"
            >
              <img
                src="../assets/images/about/image_3.jpg"
                alt="Plomeros 911 nosotros"
                class="w-100 rounded-4"
              />
            </div>
            <div
              class="offset-xl-1 offset-xxl-1 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 my-auto fix-about-image"
            >
              <img
                src="../assets/images/about/image_4.jpg"
                alt="Plomeros 911 nosotros"
                class="w-100 rounded-4"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import MainComponent from "@/components/Main.vue";
export default {
  name: "AboutView",
  components: {
    MainComponent,
  },
};
</script>
